import { provideGlobalContext } from '@adornis/functional-lit/directive-provide-context.js';
import { translationContext } from '@adornis/internationalization/client/translation-context.js';
import { m } from '../../localization/out/messages.js';

/**
 * Wires paraglide messages into the lit translation context so
 * `@adornis/generated-form` (and anything else reading `useTranslationContext()`)
 * can resolve form-field labels, placeholders, and enum-value labels.
 *
 * MUST be called once from every entrypoint's startup — main client AND every
 * standalone embed bundle. Without it, the UI shows literal keys like
 * `cv_extract_form_enum_department` instead of translations.
 */
export const setupParaglideTranslationContext = () => {
  provideGlobalContext(translationContext, m);
};
